
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Sun, Activity, CircleDollarSign } from "lucide-react";
import { Gerador } from "@/types";

interface GeradoresAtivosProps {
  topGeradores: Gerador[];
}

const GeradoresAtivos = ({ topGeradores }: GeradoresAtivosProps) => {
  return (
    <Card className="lg:col-span-2 border-blue-100">
      <CardHeader className="border-b border-blue-50">
        <CardTitle className="text-blue-700">Geradores Ativos</CardTitle>
        <CardDescription>Geradores de energia renovável</CardDescription>
      </CardHeader>
      <CardContent className="p-0">
        <div className="divide-y divide-blue-50">
          {topGeradores.length > 0 ? (
            topGeradores.map((gerador) => (
              <div key={gerador.id} className="flex justify-between items-center p-4">
                <div className="flex items-center">
                  <div className="w-10 h-10 rounded-full bg-yellow-100 flex items-center justify-center text-yellow-700 mr-3">
                    <Sun className="h-5 w-5" />
                  </div>
                  <div>
                    <p className="font-medium text-blue-900">{gerador.nomeTitular}</p>
                    <div className="flex items-center space-x-4 text-sm">
                      <span className="text-muted-foreground flex items-center">
                        <Activity className="h-3 w-3 mr-1" /> {gerador.geracaoEstimada} kWh
                      </span>
                      <span className="text-muted-foreground flex items-center">
                        <CircleDollarSign className="h-3 w-3 mr-1" /> R$ {gerador.tarifaVenda.toFixed(4)}/kWh
                      </span>
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-sm font-semibold text-blue-600">{gerador.creditosDisponiveis.toFixed(0)} kWh</div>
                  <div className="text-xs text-muted-foreground">disponíveis</div>
                </div>
                <Button asChild variant="ghost" size="sm" className="text-blue-600 hover:text-blue-800 hover:bg-blue-50">
                  <Link to={`/geradores/${gerador.id}`}>
                    Ver
                  </Link>
                </Button>
              </div>
            ))
          ) : (
            <div className="py-8 text-center text-muted-foreground">
              Nenhum gerador cadastrado
            </div>
          )}
        </div>
        
        <div className="p-4 flex justify-center border-t border-blue-50">
          <Button asChild variant="outline" className="border-blue-600 text-blue-600 hover:bg-blue-50">
            <Link to="/geradores">
              <Sun className="h-4 w-4 mr-2" />
              Ver todos
            </Link>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default GeradoresAtivos;
